<script lang="ts" setup>
import CBaseBlock from '@/presentation/components/base/CBaseBlock.vue'
import { default as PButton } from 'primevue/button'
import { storeToRefs } from 'pinia'
import { useSchoolStore } from '@/presentation/stores/school/school.ts'
import CSchoolsListItem from '@/presentation/components/schools/CSchoolsListItem.vue'
import { useRouter } from 'vue-router'

const router = useRouter()

const { allSchools } = storeToRefs(useSchoolStore())

const createSchool = () => {
  router.push({ name: 'schools-create' })
}
</script>

<template>
  <c-base-block :toggleable="false" title="Liste des établissements">
    <div class="col-span-12">
      <p-button
        label="Créer un établissement"
        icon="pi pi-plus"
        severity="primary"
        size="small"
        @click="createSchool"
      />
    </div>

    <div v-if="allSchools.length > 0" class="col-span-12 mt-4 grid w-full grid-cols-12 gap-4">
      <template v-for="school in allSchools" :key="school.id">
        <div class="col-span-6 lg:col-span-3">
          <c-schools-list-item :school="school" />
        </div>
      </template>
    </div>
    <p class="" v-else>Il n'y a aucun établissement.</p>
  </c-base-block>
</template>
